import FundDetailsTabRow from 'components/Pages/FundsCenter/FundDetails/FundDetailsTabRow';
import FundDetailsTabSkeleton from 'components/Pages/FundsCenter/FundDetails/FundDetailsTabSkeleton';
import AlertMessageBase from 'components/Generic/AlertMessageBase';
import { useI18n } from 'next-localization';
import usePayload from 'hooks/useFundDetailsRequestPayload';
import useHelpers from 'hooks/helpers';
import { useFetchManagementTabDataQuery } from '@/store/fundDetails/services/fundDetailsApi';
import FundDetailsList from '../components/FundDetailsList';

const FundDetailsManagementTab = ({ title }: string) => {
  const payload = usePayload();
  const { getErrorDictionary } = useHelpers();
  const { t } = useI18n();
  const { data, isLoading, error } = useFetchManagementTabDataQuery(payload);
  return (
    <section className="default-section-padding background-white">
      <FundDetailsTabRow>
        <h2>{title}</h2>

        <div className="mt-3">
          {isLoading ? (
            <FundDetailsTabSkeleton />
          ) : error ? (
            <AlertMessageBase type="error" title={t(getErrorDictionary(error))} />
          ) : data && data.management.length ? (
            <FundDetailsList data={data.management} />
          ) : (
            <div className="body-default">{t('noResultsMessage')}</div>
          )}
        </div>
      </FundDetailsTabRow>
    </section>
  );
};

export default FundDetailsManagementTab;
